import React, { useEffect, useState } from "react";
import swal from "sweetalert";

import { GetLanguageString, NoResult } from "../../helper/Components";
import LFCSearch from "./LfcKpiReportSearch";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { ApiUnit } from "../../unit/ApiUnit";
import { LoadingSpinner } from "../../../constants/const";
import { ApiLetterForCounselling } from "../../config/letterForCounselling/ApiLetterForCounselling";
import { Button, ButtonGroup, Col, Row, Table } from "reactstrap";
import { RiFileExcel2Line } from "react-icons/ri";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";
import { ShowToast } from "../../shared/ShowToast";
import { toast, ToastContainer } from "react-toastify";
import { GetCustomStyles, GetSelectedLanguage } from "../../helper/Method";

const LfcKpiReport = () => {
  const [loading, setLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const unitTypeName = encryptStorage.getItem("unitTypeName");
  const [lfcReport, setLfcReport] = useState([]);
  const [unit, setUnit] = useState({
    unitId: loggedInUnitId,
    unitName: "",
    unitTypeName: unitTypeName,
  });
  const [searchButton, setSearchButton] = useState(false);
  const { t } = useTranslation();
  const [searchLfcModel, setSearchLfcModel] = useState({
    unitId: loggedInUnitId,
    loggedInUnitId: loggedInUnitId,
    activePage: 1,
    isSubUnits: true,
    lfcType: {},
    startDate: new Date(),
    endDate: new Date(),
    sortModel: {},
  });

  useEffect(() => {
    if (unit.unitId === 0) {
      ApiUnit()
        .getUnit(loggedInUnitId, loggedInUnitId)
        .then((res) => {
          let temp = res.data.unitList[0];
          setSearchLfcModel({
            unitId: temp.id,
            activePage: 1,
          });
          setUnit({ unitId: temp.id, unitName: temp.name });
        })
        .catch((err) => console.log(err));
    }
  }, [unit.unitId, loggedInUnitId]);

  useEffect(() => {
    setLoading(true);

    if (searchButton) {
      ApiLetterForCounselling()
        .GetLfcConsolidatedKpiReport(searchLfcModel)
        .then((res) => {
          setLfcReport(res.data);
          setLoading(false);
        })
        .catch((err) => {
          swal({
            title: err,
            icon: "error",
            buttons: "OK",
          });
          setLoading(false);
        });
    }
  }, [searchLfcModel, searchButton]);

  const allQuestions =
    lfcReport.yearlyData
      ?.flatMap((y) => y.months || [])
      ?.flatMap((m) => m.questionSummaries || [])
      ?.filter(
        (q, i, arr) =>
          q && arr.findIndex((x) => x.questionId === q.questionId) === i
      ) || [];
  const selectedLang = localStorage.getItem("i18nextLng");

  const downloadExcel = () => {
    if (searchButton) {
      const toastId = toast.loading(t("downloading_excel"));

      ApiLetterForCounselling()
        .GetLfcConsolidatedKpiReportExcel(searchLfcModel)
        .then((res) => {
          if (!res || !res.data) {
            throw new Error("Empty response");
          }
          // ✅ Use correct MIME type for Excel
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // ✅ Choose filename dynamically if needed
          saveAs(blob, "KPIReport.xlsx");

          ShowToast(toastId, "downloaded_excel", "success");
        })
        .catch((err) => {
          console.error("Excel download error:", err);
          ShowToast(toastId, "error_downloading_excel", "error");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  // const downloadPdf = () => {
  //   if (searchButton) {
  //     const toastId = toast.loading(t("downloading_pdf"));
  //     ApiLetterForCounselling()
  //       .GetLfcConsolidatedKpiReportPdf(searchLfcModel)
  //       .then((res) => {
  //         const blob = new Blob([res.data], {
  //           type: "application/pdf",
  //         });
  //         saveAs(blob, "IjtimaWiseIjtimaReport.pdf");
  //         ShowToast(toastId, "downloaded_pdf", "success");
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         ShowToast(toastId, "Failed to download PDF.", "error");
  //       })
  //       .then(() => {
  //         setLoading(false);
  //       });
  //   }
  // };
  return (
    <div>
      <div className="wrapper wrapper-custom wrapper-content animated fadeInRight">
        <div className="ibox ">
          <div className="ibox-title">
            <h5>{<GetLanguageString props="common_generate_report" />}</h5>
          </div>
          <div className="ibox-content">
            <LFCSearch
              unitId={unit.unitId}
              setUnit={setUnit}
              searchLfcModel={searchLfcModel}
              setSearchLfcModel={setSearchLfcModel}
              setSearchButton={setSearchButton}
            />
          </div>
          <ToastContainer
            autoClose={3000}
            bodyClassName={GetSelectedLanguage()}
            closeOnClick
            pauseOnHover={false}
            draggable
          />
        </div>
        {searchButton && (
          <div className="ibox ">
            <div className="ibox-title">
              <h5>
                {
                  <GetLanguageString props="letter_for_counselling_kpi_report" />
                }
              </h5>
              <ButtonGroup className={GetCustomStyles().btn_style}>
                <Button color="default" size="sm" onClick={downloadExcel}>
                  <RiFileExcel2Line
                    size={15}
                    color="#009440"
                    style={{ marginRight: 3, marginBottom: 1 }}
                  />
                  {<GetLanguageString props="member_report_export_excel" />}
                </Button>
                {/* <Button color="default" size="sm" onClick={downloadPdf}>
                  <RiFilePdf2Line
                    size={15}
                    color="#FF0000"
                    className={GetCustomStyles().fa_style}
                  />
                  {<GetLanguageString props="member_report_export_pdf" />}
                </Button> */}
              </ButtonGroup>
            </div>
            <div className="ibox-content" style={{ overflowX: "visible" }}>
              {!loading ? (
                lfcReport.yearlyData.length !== 0 ? (
                  <>
                    <Row>
                      <Col xs={12}>
                        <p
                          style={{
                            textAlign: "center",
                            fontWeight: "bold",
                            marginBottom: "10px",
                            fontSize: "22px",
                          }}
                          className="ur"
                        >
                          {lfcReport.reportTitle}
                        </p>
                      </Col>

                      <Col xs={12} style={{ overflowX: "auto" }}>
                        <Table bordered responsive>
                          <thead>
                            {/* ---- Year Row ---- */}
                            <tr>
                              <th colSpan={4}></th>
                              {lfcReport.yearlyData.map((yearData, yIndex) => (
                                <th
                                  key={yIndex}
                                  colSpan={yearData.months.length}
                                  style={{
                                    textAlign: "center",
                                    borderTop: "2px solid #000",
                                    borderInlineStart:
                                      yIndex === 0 ? "2px solid #000" : "none",
                                    borderInlineEnd: "2px solid #000",
                                  }}
                                >
                                  {yearData.year}
                                </th>
                              ))}
                            </tr>

                            {/* ---- Month Row ---- */}
                            <tr>
                              <th colSpan={2}></th>

                              <th
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {
                                  <GetLanguageString props="settings_letter_for_counselling_questions" />
                                }
                              </th>
                              <th style={{ textAlign: "center" }}>KPI</th>
                              {lfcReport.yearlyData.map((yearData, yIndex) =>
                                yearData.months.map((month, mIndex) => {
                                  const isFirstMonthOfYear = mIndex === 0;
                                  const isLastMonthOfYear =
                                    mIndex === yearData.months.length - 1;
                                  return (
                                    <th
                                      key={`${yearData.year}-${month.month}`}
                                      className="ur"
                                      style={{
                                        textAlign: "center",
                                        borderInlineStart: isFirstMonthOfYear
                                          ? "2px solid #000"
                                          : "1px solid #dee2e6",
                                        borderInlineEnd: isLastMonthOfYear
                                          ? "2px solid #000"
                                          : "1px solid #dee2e6",
                                      }}
                                    >
                                      {month.monthName}
                                    </th>
                                  );
                                })
                              )}
                            </tr>

                            {/* ---- Overall submission row ---- */}
                            <tr>
                              <th style={{ textAlign: "center" }}>#</th>
                              <th style={{ textAlign: "center" }}>
                                {
                                  <GetLanguageString props="settings_letter_for_counselling_question_question_number" />
                                }
                              </th>

                              <th
                                style={{
                                  textAlign:
                                    selectedLang === "ur" ? "left" : "right",
                                }}
                              >
                                {
                                  <GetLanguageString props="receive_percentage" />
                                }
                              </th>
                              <th style={{ textAlign: "center" }}>
                                {
                                  <GetLanguageString props="create_report_conducted_total" />
                                }{" "}
                                {lfcReport.totalSubmittedLfcs}
                              </th>
                              {lfcReport.yearlyData.map((yearData, yIndex) =>
                                yearData.months.map((month, mIndex) => {
                                  const isFirstMonthOfYear = mIndex === 0;
                                  const isLastMonthOfYear =
                                    mIndex === yearData.months.length - 1;
                                  return (
                                    <th
                                      key={`${yearData.year}-${month.month}-overall`}
                                      style={{
                                        textAlign: "center",
                                        borderInlineStart: isFirstMonthOfYear
                                          ? "2px solid #000"
                                          : "1px solid #dee2e6",
                                        borderInlineEnd: isLastMonthOfYear
                                          ? "2px solid #000"
                                          : "1px solid #dee2e6",
                                      }}
                                    >
                                      {month.receivedPercentage}%
                                    </th>
                                  );
                                })
                              )}
                            </tr>
                          </thead>

                          <tbody>
                            {allQuestions.map((q, qIndex) => (
                              <tr key={qIndex}>
                                <td style={{ textAlign: "center" }}>
                                  {qIndex + 1}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {q.questionNumber}
                                </td>
                                <td className="ur" colSpan={1}>
                                  {q.questionText}
                                </td>
                                <td style={{ textAlign: "center" }}>
                                  {q.targetPercentage ?? 0}%
                                </td>

                                {lfcReport.yearlyData.map((yearData, yIndex) =>
                                  yearData.months.map((month, mIndex) => {
                                    const isFirstMonthOfYear = mIndex === 0;
                                    const isLastMonthOfYear =
                                      mIndex === yearData.months.length - 1;
                                    const isLastQuestionRow =
                                      qIndex === allQuestions.length - 1; // 👈 check last row
                                    const question =
                                      month.questionSummaries?.find(
                                        (x) => x.questionId === q.questionId
                                      );

                                    return (
                                      <td
                                        key={`${yearData.year}-${month.month}-${q.questionId}`}
                                        style={{
                                          textAlign: "center",
                                          borderInlineStart: isFirstMonthOfYear
                                            ? "2px solid #000"
                                            : "1px solid #dee2e6",
                                          borderInlineEnd: isLastMonthOfYear
                                            ? "2px solid #000"
                                            : "1px solid #dee2e6",
                                          borderBottom: isLastQuestionRow
                                            ? "2px solid #000"
                                            : "1px solid #dee2e6", // 👈 new
                                        }}
                                      >
                                        {question
                                          ? `${question.ratedPercentage}%`
                                          : "0%"}
                                      </td>
                                    );
                                  })
                                )}
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <NoResult />
                )
              ) : (
                LoadingSpinner()
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LfcKpiReport;
